import Cookies from 'js-cookie';
export const getValueFromCookie = (cookieName: string) => {
  const cookies = document?.cookie?.split(';');
  const loginCookie = cookies
    ?.map((pair) => pair.trim())
    ?.find((el: string) => el.startsWith(cookieName))
    ?.split('=')[1];
  if (!loginCookie) {
    return null;
  }
  return loginCookie;
};

export const removeCookie = (cookieName: string) => {
  Cookies.remove(cookieName);
};

export const createCookie = (
  cookieName: string,
  cookieValue: string,
  expirationTime?: number
) => {
  const options = expirationTime ? { expires: expirationTime } : {};
  Cookies.set(cookieName, cookieValue, options);
};
